import React from 'react'

import ButtonRow from 'components/base/Button/Row'
import InsuranceTypeIcon from 'components/base/Icon/InsuranceTypeIcon'
import Link, { Theme as LinkTheme } from 'components/base/Link'
import Title from 'components/base/Title'

import {
  Product,
  Wrap,
} from './styles'

import { Props } from './types'

const ProductListItem: React.FC<Props> = ({
  children,
  icon,
  link,
  title,
}): React.ReactElement => {
  const headingContent = (
    <>
      {icon && <InsuranceTypeIcon theme={icon} colored={true} hasMargin={true} />}
      <Title level={2}>{title}</Title>
    </>
  )

  return (
    <Wrap>
      <Product>
        {(link && <Link theme={LinkTheme.unstyled} to={link}>{headingContent}</Link>) || <>{headingContent}</>}
        {children}
      </Product>
      {(link && (
        <ButtonRow>
          <Link theme={LinkTheme.button} to={link}>
            About {title}
          </Link>
        </ButtonRow>
      ))}
    </Wrap>
  )
}

export default ProductListItem
